<template>
  <f7-page name="hydro-vystrahy" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Hydro výstrahy</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar bottom>
      <f7-link tab-link="#tab-hv-okres" tab-link-active>Okres</f7-link>
      <f7-link tab-link="#tab-hv-map" >Mapa</f7-link>
    </f7-toolbar>

    <f7-tabs class="wh-100">
      <f7-tab id="tab-hv-okres" @tab:show="onTableTabShow($event)" tab-active>
        <f7-block strong class="no-padding no-margin no-border-top">
          <template v-if="isRegionsLoaded">
            <f7-list class="ss-list">
              <f7-list-item title="Okres:"
                            class="hydro-vystrahy-ss-list"
                            smart-select
                            :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true, closeOnSelect: true, pageTitle:'Vyberte okres', popupCloseLinkText:'Návrat', searchbar: {  removeDiacritics:true, customSearch: true, on: { search: searchFromBeginning }, }, searchbarPlaceholder: 'Hľadať...'}">
                <select name="station" v-model="selectedRegion" @change="onSelectHydroWarningRegion($event)">
                  <option v-for="(value, key) in regions" :key="key" :value="value.id_okres">{{ value.nazov_okres }}</option>
                </select>
                <div slot="root-start" class="float-left" style="margin: 3px;" v-if="isGeolocationEnabled">
                  <f7-button @click="selectOkresByLocation" class="text-color-black" icon-f7="placemark_fill"></f7-button>
                </div>
              </f7-list-item>
            </f7-list>
            <f7-block v-if="selectedRegion !== null" class="no-margin no-padding">

              <template v-if="isDataLoaded && currentWarning===null">
                <f7-block strong class="text-align-center no-margin-top vystraha-0">
                  Pre okres <strong>{{ currentRegion.nazov_okres }}</strong> nie sú vydané žiadne hydrologické výstrahy
                </f7-block>
              </template>
              <template v-else-if="isDataLoaded && currentWarning !== null">
                <f7-card>
                  <f7-card-header :class="'vystraha-' + currentWarning.stupen">{{ currentWarning.stupen }}. stupeň</f7-card-header>
                  <f7-card-content>
                    <div class="display-inline-block">
                      <img v-for="druh in currentWarning.druhy" :src="'static/shmu/img/hydrovystrahy/'+druh.druh_id+'.svg'" width="64">
                    </div><br>
                    <strong>Druh výstrahy:</strong>
                    <ul class="no-margin mb-1">
                      <li v-for="druh in currentWarning.druhy">{{ druh.druh_nazov }}</li>
                    </ul>
                    <strong>Platnosť od:</strong> od {{ currentWarning.dt_platnost_od*1000 | moment('DD.MM.YYYY HH:mm') }}<br>
                    <strong>Platnosť do:</strong> do <template v-if="!currentWarning.dt_platnost_do">odvolania</template>
                    <template v-else>{{ currentWarning.dt_platnost_do*1000 | moment('DD.MM.YYYY HH:mm') }}</template>
                    <div class="mt-1 font-weight-bold">Výstraha:</div>
                    <p class="no-margin">{{ currentWarning.text_vystrahy }}</p>

                  </f7-card-content>
                  <f7-card-footer>
                    Aktualizované: {{ currentWarning.dt_add*1000 | moment('DD.MM.YYYY HH:mm') }}
                  </f7-card-footer>
                </f7-card>
              </template>
              <template v-else>
                <f7-block strong class="text-align-center no-margin-top">
                  Načítavam údaje...
                </f7-block>
              </template>

            </f7-block>

          </template>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-hv-map" class="wh-100" @tab:show="onMapTabShow($event)">

        <div class="hydro-vystrahy-top-bar vystraha-0" v-if="isDataLoaded && !isWarnings">
          Aktuálne nie sú vydané žiadne hydrologické výstrahy
        </div>

        <l-map :zoom="zoom"
               :center="center"
               :options="mapOptions"
               ref="mapHydroVystrahy"
               class="hydro-vystrahy-map"
        >
          <l-control-zoom position="bottomright"  ></l-control-zoom>
          <l-tile-layer
              ref="layerBg"
              :url="url"
              :attribution="attribution"
          />
          <l-tile-layer :url="borderUrl" />
          <l-tile-layer :url="riversUrl" :opacity="0.5" />
          <l-geo-json
              ref="geoJsonLayer"

              :geojson="hydroVystrahyGeoJsonData"
              :options-style="styleFunction"
              :options="geoJsonOptions"
          />

          <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
            </div>
          </l-control>

          <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
            </div>
          </l-control>

        </l-map>
      </f7-tab>

    </f7-tabs>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControlZoom, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import geoJsonHydroMap from '../static/shmu/maps/hydro_map';
import searchMixin from "../js/mixin";
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl
  },
  mixins: [
    searchMixin,
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      latestData: [],
      isDataLoaded: false,
      isRegionsLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      regions: [],
      selectedData: null,
      selectedRegion: null,
      isWarnings: false,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      hydroVystrahyGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  computed: {
    geoJsonOptions() {
      return {
        onEachFeature: this.onEachFeatureFunction
      };
    },
    currentRegion() {
      if (this.selectedRegion) {
        return this.regions.find(item => parseInt(item.id_okres) === parseInt(this.selectedRegion))
      }
      return null;
    },
    currentWarning() {
      if (this.selectedRegion) {
        let res = this.latestData.find(item => parseInt(item.okres.id_okres) === parseInt(this.selectedRegion))
        if (typeof res === "undefined") {
          return null;
        }
        return res;
      }
      return null;
    },
    styleFunction() {
      const myLatestData = this.latestData;

      return (feature) => {
        let curfillColor = 'rgb(41, 214, 91)';
        if (myLatestData) {
          let obj = myLatestData.find(o => o.okres.skratka === feature.properties.SKRATKA)
          if (typeof obj !== "undefined") {
            switch (obj.stupen) {
              case 1: {
                curfillColor = 'rgb(255, 255, 1)';
                break;
              }
              case 2: {
                curfillColor = 'rgb(243, 138, 57)';
                break;
              }
              case 3: {
                curfillColor = 'rgb(254, 1, 4)';
                break;
              }
            }
          }
        }

        return {
          fillColor: curfillColor ,
          weight: 1,
          opacity: 0.8,
          color: 'black',
          fillOpacity: 0.8
        }


      };
    },
    onEachFeatureFunction() {
      const self = this;
      if (!this.latestData) {
        return () => {};
      }
      return (feature, layer) => {
        let obj = self.latestData.find(o => o.okres.skratka === feature.properties.SKRATKA)
        if (typeof  obj !== "undefined") {
          layer.on({
            click: function (v) {
              self.$f7router.navigate('/hydro-vystrahy/' + v.target.feature.properties.SKRATKA);
            }
          });
        }
      };
    }
  },
  watch: {
    latestData: function() {
      const self = this;
      self.hydroVystrahyGeoJsonData = geoJsonHydroMap;
      if (self.latestData.length > 0) {
        self.isWarnings = true;
      } else {
        this.isWarnings = false;
      }



    },
    isRegionsLoaded: function () {
      if (this.selectedRegion === null) {
        this.$nextTick(() => {
          this.$f7.smartSelect.get('.hydro-vystrahy-ss-list .smart-select').open();
        });
      }
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        self.loadHydroVystrahyRegions();
      }

    },
    loadHydroVystrahyRegions: function() {
      const self = this;

      let cached_regions = self.$ls.get('hydro_warnings_regions');
      if (cached_regions !== null) {
        self.regions = cached_regions;
        self.selectedRegion = this.$ls.get('hydro_warnings_selected_region');
        self.isRegionsLoaded = true;
        self.loadHydroVystrahy();
      } else {

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getwarningsregions', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.regions = response.data;
                self.selectedRegion = this.$ls.get('hydro_warnings_selected_region');
                self.isRegionsLoaded = true;
                self.loadHydroVystrahy();
                self.$ls.set('hydro_warnings_regions', self.regions, 7 * 24 * 60 * 60 * 1000); //  7 dni
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať zoznam okresov pre hydrologické výstrahy', 'Nastala chyba');
              }
              self.$f7.dialog.close();

            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }

    },
    loadHydroVystrahy: function() {
      const self = this;

      let cached = self.$ls.get('hydro_vystrahy');
      if (cached !== null) {
        self.latestData = cached;
        self.isDataLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getwarnings', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.latestData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();
                self.$ls.set('hydro_vystrahy', self.latestData, 50 * 1000); //  50 sekund
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 2 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o hydrologických výstrahách', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    initMap() {
      const self = this;
      //this.$refs.mapZrazky.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet ZRAZKY init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapHydroVystrahy.mapObject);

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 2*60) { // ak posledne stiahnutie bolo pred vic ako 2 min, tak refresh
        this.pageReload(null, false);
      }
    },
    onMapTabShow(e) {
      // console.log('onMapTabShow');
      this.loadHydroVystrahy();
      this.$refs.mapHydroVystrahy.mapObject.invalidateSize();
    },
    onTableTabShow(e) {
      // console.log('onTableTabShow');
      this.pageReload(null, false);
    },
    onSelectHydroWarningRegion(event) {
      this.selectedRegion = event.target.value;
      this.loadHydroVystrahy();
      this.$ls.set('hydro_warnings_selected_region', this.selectedRegion);
    },

    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapHydroVystrahy.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapHydroVystrahy.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapHydroVystrahy.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    },
    selectOkresByLocation() {
      if (this.isGeolocationEnabled) {
        this.getGeoLocation(this.onLocationFoundAndSelectOkres, this.onLocationError)
      }
    },
    onLocationFoundAndSelectOkres(e) {
      this.currentLocation = e.coords;
      const self = this;

      if (this.currentLocation !== null) {


        // posli suradnice na backend a ziskaj okres
        Axios.get(SHMUconf.API_BASE_URL + 'global/getdistrictbylatlon?lat=' + this.currentLocation.latitude + '&lon=' + this.currentLocation.longitude, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                let identifikovany_okres = response.data;
                let identifikovany_okres_skratka = identifikovany_okres.okres_skratka;

                let detectedOkresFromList = this.regions.find(item => item.skratka.indexOf(identifikovany_okres_skratka) === 0)
                if (detectedOkresFromList) {
                    this.selectedRegion = detectedOkresFromList.id_okres;

                    this.loadHydroVystrahy();
                    this.$ls.set('hydro_warnings_selected_region', this.selectedRegion);
                    this.$f7.smartSelect.get('.hydro-vystrahy-ss-list .smart-select').setValue(this.selectedRegion);
                } else {
                  self.$f7.dialog.alert('Nepodarilo sa identifikovať okres na základe vašich súradníc', 'Nastala chyba');
                }

              } else {
                self.$f7.dialog.alert('Nepodarilo sa identifikovať okres na základe vašich súradníc', 'Nastala chyba');
              }
              self.$f7.dialog.close();

            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });

      }

    },



  }

};
</script>

<style lang="scss">

.hydro-vystrahy-top-bar {
  z-index: 1100;
  position: absolute;
  top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
  left: 0;
  width:100%;
  text-align:center;
  font-size: 12px;
  background-color: rgb(41, 214, 91);
  color: white;
  padding: 5px 0;

}


.hydro-vystrahy-map {
  width: 100%;
  height: 100%;
}


</style>
